import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=99324c1e&scoped=true&"
import script from "./SysCategoryList.vue?vue&type=script&lang=js&"
export * from "./SysCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./SysCategoryList.vue?vue&type=style&index=0&id=99324c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99324c1e",
  null
  
)

export default component.exports